export default "/Yi Sunsin.glb";